import {CamFilledIcon} from 'src/layouts/main-layout/app-sidebar/icons/cam-filled.icon'
import {CamIcon} from 'src/layouts/main-layout/app-sidebar/icons/cam.icon'
import {ClipboardListFilledIcon} from 'src/layouts/main-layout/app-sidebar/icons/clipboard-list-filled.icon'
import {ClipboardListIcon} from 'src/layouts/main-layout/app-sidebar/icons/clipboard-list.icon'
import {DashboardFilledIcon} from 'src/layouts/main-layout/app-sidebar/icons/dashboard-filled.icon'
import {DashboardIcon} from 'src/layouts/main-layout/app-sidebar/icons/dashboard.icon'
import {SlidersFilledIcon} from 'src/layouts/main-layout/app-sidebar/icons/sliders-filled.icon'
import {SlidersIcon} from 'src/layouts/main-layout/app-sidebar/icons/sliders.icon'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

interface Props {
  active?: boolean
  icon: string | null
  className?: string
}

type IconConfig = {
  default: React.ElementType
  active?: React.ElementType
}

const iconMap: Record<string, IconConfig> = {
  dashboard: {
    default: DashboardIcon,
    active: DashboardFilledIcon,
  },
  monitoramento: {
    default: CamIcon,
    active: CamFilledIcon,
  },
  cadastros: {
    default: ClipboardListIcon,
    active: ClipboardListFilledIcon,
  },
  configuracoes: {
    default: SlidersIcon,
    active: SlidersFilledIcon,
  },
}

export function AppSidebarNavIcon({icon, active, className}: Props) {
  const config = icon ? iconMap[icon] : undefined
  const Icon = (active ? (config?.active ?? config?.default) : config?.default) ?? CamIcon

  return <Icon aria-hidden className={cn('text-sidebar-foreground size-4 shrink-0', active && 'text-sidebar-foreground', className)} />
}
